
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const apiBaseUrl = process.env.REACT_APP_SERVER_URL;

  // Attempt to migrate guest chats to this user
  const convertGuestSession = useCallback(async () => {
    try {
      // We no longer check document.cookie because HttpOnly cookies are invisible to JS.
      // We just call the endpoint and let the backend decide.
      await axios.post(
        `${apiBaseUrl}/api/auth/convert-guest`,
        {},
        { withCredentials: true }
      );
    } catch (err) {
      // Non-critical, ignore errors
      console.log("Guest migration check complete (none found or already done)");
    }
  }, [apiBaseUrl]);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await axios.get(
          `${apiBaseUrl}/api/auth/profile`,
          { withCredentials: true }
        );
        setUser(data.data);
        // Await migration so it finishes before Dashboard fetches
        await convertGuestSession();
        localStorage.setItem('migration_done', 'true'); // Signal for Dashboard
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [apiBaseUrl, convertGuestSession]);

  const logout = async () => {
    await axios.post(`${apiBaseUrl}/api/auth/logout`, {}, { withCredentials: true });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout, convertGuestSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);



